import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchWaitingList, updateWaitingList } from './actions';
import WaitingListForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleWaitingListSubmit = this.handleWaitingListSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchWaitingList } = this.props;
		const waitingListId = match.params.id;

		if (waitingListId) {
			fetchWaitingList(waitingListId);
		}
	}

	handleWaitingListSubmit(values) {
		const { waitingList, updateWaitingList } = this.props;

		updateWaitingList(waitingList.id, values);
	}

	render() {
		const { waitingList, isReadonly, waitingListStatusTypes, t } = this.props;
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<WaitingListForm isReadonly={isReadonly} onSubmit={this.handleWaitingListSubmit} initialValues={waitingList} waitingListStatusTypes={waitingListStatusTypes} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const waitingListId = ownProps.match.params.id;

	const {
		entities: { waitingLists },
		lookups: { waitingListStatusTypes },
		auth: { currentUser }
	} = state;

	return {
		waitingList: waitingLists[waitingListId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WaitingList'),
		waitingListStatusTypes
	};
};

export default connect(mapStateToProps, {
	fetchWaitingList,
	updateWaitingList
})(withTranslation()(Details));